import React from 'react';

export default ({children, opened}) => {
    return (
        <div className = { `popup__wrapper fast${opened ? ' in' : ''}` }>
            <div className = { 'popup popup-project in' }>
                {children}
            </div>

            <div className = 'popup__overlay' />
        </div>
    );
};
